<template>


            <div class="panel panel-primary">
                <div class="panel-heading">
                    <h3 class="panel-title">Performance Over Time</h3>
                </div>
                <div class="panel-body">
                    <form class="form-inline">
                        <div class="form-group form-group-sm">
                            <label for="event_code" class="control-label">Event:</label>
                                <select class="form-control" v-model="eventCode" v-on:change="fetchTimes" id="event_code" name="event_code">
                                  <option value="50FC">50FC</option>
                                  <option value="100FC">100FC</option>
                                  <option value="200FC">200FC</option>
                                  <option value="400FC">400FC</option>
                                  <option value="800FC">800FC</option>
                                  <option value="1500FC">1500FC</option>
                                  <option value="50BC">50BC</option>
                                  <option value="100BC">100BC</option>
                                  <option value="200BC">200BC</option>
                                  <option value="50BR">50BR</option>
                                  <option value="100BR">100BR</option>
                                  <option value="200BR">200BR</option>
                                  <option value="50FL">50FL</option>
                                  <option value="100FL">100FL</option>
                                  <option value="200FL">200FL</option>
                                  <option value="100IM">100IM</option>
                                  <option value="200IM">200IM</option>
                                  <option value="400IM">400IM</option>
                                </select>
                        </div>
                        <div class="form-group form-group-sm">

                            <label for="filter_date" class="control-label">Date:</label>
                                <select class="form-control" v-model="filterDate" v-on:change="fetchTimes" id="filter_date" name="filter_date">
                                    <option value="THIS_SEASON" selected>This Season (September - August)</option>
                                    <option value="LAST_SEASON">Last Season (September - August)</option>
                                    <option value="LAST_SEASON_TO_TODAY">Last Season Until Today</option>
                                    <option value="THIS_MONTH">This Month</option>
                                    <option value="LAST_MONTH">Last Month</option>
                                    <option value="THIS_YEAR">This Year</option>
                                    <option value="LAST_YEAR">Last Year</option>

                                </select>
                        </div>
                    </form>
                    <canvas width="1000" height="400" id="member-times-chart"></canvas>
                </div>
                <table class="table table-striped table-condensed">
                    <thead>
                    <tr>
                        <th>Meet</th>
                        <th class="text-center">Date</th>
                        <th class="text-center">Course</th>
                        <th class="text-right">SC Time</th>
                        <th class="text-right">LC Time</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="time in times">
                        <td>{{ time.meet_name }}</td>
                        <td class="text-center">{{ time.date }}</td>
                        <td class="text-center">{{ time.course }}</td>
                        <template v-if="time.course == 'LC'">

                            <td class="text-right text-muted"><span  data-toggle="tooltip" data-placement="top" title="Converted Time">{{ time.sc_time }}</span></td>
                            <td class="text-right">{{ time.lc_time }}</td>
                        </template>
                        <template v-else>
                            <td class="text-right">{{ time.sc_time }}</td>
                            <td class="text-right text-muted"><span  data-toggle="tooltip" data-placement="top" title="Converted Time">{{ time.lc_time }}</span></td>
                        </template>
                    </tr>
                    </tbody>

                </table>
            </div>


</template>

<script>

import Chart from 'chart.js';

export default {
        props: ['asa_number'],
        data: function () {
            return {
                times: [],
                chart: null,
                chartOptions: null,
                chartData: null,
                chartContext: null,
                eventCode: "50FC",
                filterDate: null,
                asaNumber: this.asa_number
            }
        },
        methods: {
            fetchTimes() {
                console.log('Fetching times');
                axios.get('/api/member/event_times?event_code=' + this.eventCode + '&asa_number=' + this.asaNumber + '&filterDate=' + this.filterDate).then((response) => {
                    // this.times = response.data;
                    console.log(response.data);
                    this.times = response.data;
                    this.updateChartData(response.data);
                    // this.chartData = this.makeDataset(response.data);
                    this.displayChart();
                    // this.displayChart();
                });
            },
            createChart() {
                console.log('Creating chart');
                this.chartContext = document.getElementById("member-times-chart").getContext('2d');
            },
            displayChart() {
                console.log('Updating chart');
                if (this.chart != null) {
                    this.chart.destroy();
                }
                // updateChartData(times);
                this.chart = new Chart(this.chartContext, {
                  type: 'line',
                  data: this.chartData,
                  options: this.chartOptions
                });

            },
            updateChartData(times) {
                var objDatasets = {};
                objDatasets.datasets = [];
                objDatasets.datasets.push(this.makeDataset(times));
                objDatasets.datasets.push(this.makeDataset(times, 'SC'));
                objDatasets.datasets.push(this.makeDataset(times, 'LC'));
                this.chartData = objDatasets;
                // this.chart.data.datasets[0] = this.ChartData;
                // this.chart.update();
            },
            setInitialDateFilter() {
                if (moment().month() >= 9) {
                    this.filterDate = 'THIS_YEAR';
                }
                else {
                    this.filterDate = 'THIS_SEASON';
                }
            },
            makeDataset(times, type) {
                var newChartData = [];
                var newDataset = null;
                var timeToPlot;
                var theColour;
                var plotThisTime;
                var theLabel;

                theLabel = "Actual Swim Times";
                if (type == 'SC') {
                    theLabel = 'Short Course Times (incl. conversions)';
                }
                if (type == 'LC') {
                    theLabel = 'Long Course Times (incl. conversions)';
                }

                for (var time of times) {
                    console.log(type);
                    timeToPlot = time.time_sec;
                    theColour = 'blue';
                    plotThisTime = true;
                    if (type == 'SC') {
                            timeToPlot = time.sc_time_sec;
                            theColour = 'green';
                            plotThisTime = true;
                    }
                    if (type == 'LC') {
                            timeToPlot = time.lc_time_sec;
                            theColour = 'orange';
                            plotThisTime = true;
                    }
                    if (plotThisTime == true) {
                        newChartData.push ({
                            x: moment(time.date,"DD/MM/YYYY"),
                            y: timeToPlot
                        });
                    }
                }

                newDataset = {
                        label: theLabel,
                        data: newChartData,
                        lineTension: 0.25,
                        fill: false,
                        borderColor: theColour,
                        backgroundColor: 'transparent',
                        pointBorderColor: theColour,
                        pointBackgroundColor: 'rgba(0,150,255,0.5)',
                        borderDash: [5, 5],
                        pointRadius: 10,
                        pointHoverRadius: 20,
                        pointHitRadius: 30,
                        pointBorderWidth: 2,
                        pointStyle: 'rectRounded'
                      };

                return newDataset;
                // newDatasets = {
                //       datasets: [{
                //         label: "Times",
                //         data: newChartData,
                //         lineTension: 0.25,
                //         fill: false,
                //         borderColor: theColour,
                //         backgroundColor: 'transparent',
                //         pointBorderColor: theColour,
                //         pointBackgroundColor: 'rgba(0,150,255,0.5)',
                //         borderDash: [5, 5],
                //         pointRadius: 10,
                //         pointHoverRadius: 20,
                //         pointHitRadius: 30,
                //         pointBorderWidth: 2,
                //         pointStyle: 'rectRounded'
                //       }]
                //     };
                // return newDatasets;
            },
            setChartOptions() {
                this.chartOptions = {
                  responsive:true,
                  tooltips: {
                    callbacks: {
                        title: function(tooltipItems, chart) {
                            return tooltipItems[0].xLabel;
                        },
                        label: function(tooltipItem, chart) {
                            var intValue = parseInt(tooltipItem.yLabel) | 0;
                            var valHundredths = Math.round((tooltipItem.yLabel - intValue) * 100);
                            var valSeconds = parseInt(tooltipItem.yLabel) || 0;
                            var valMinutes = parseInt(valSeconds / 60);

                            valSeconds = valSeconds - (valMinutes * 60);

                            var pointLabel = tooltipItem.yLabel;
                            if (valMinutes > 0) {
                                pointLabel = ("00" + valMinutes).slice(-2) + ":" + ("00" + valSeconds).slice(-2) + "." + (valHundredths + "00").slice(0,2);
                            }
                            else {
                                pointLabel = ("00" + valSeconds).slice(-2) + "." + (valHundredths + "00").slice(0,2);
                            }

                            return pointLabel;
                        }
                    }
                  },
                  legend: {
                    display: true,
                    position: 'top',
                    labels: {
                      boxWidth: 80,
                      fontColor: 'black'
                    }
                  },
                  scales: {
                    xAxes: [{
                      type: "time",
                      time: {
                        unit: 'month',
                        unitStepSize: 1,
                        tooltipFormat: "Do MMM YYYY"
                      }
                    }],
                    yAxes: [{
                      gridLines: {
                        color: "black",
                        borderDash: [2, 5],
                      },
                      scaleLabel: {
                        display: true,
                        labelString: "Time",
                        fontColor: "blue"
                      },
                      ticks: {
                        callback: function(value, index, values) {
                            console.log('Formatting value ' + value);

                            var intValue = parseInt(value) | 0;
                            var valHundredths = (value - intValue) * 100;
                            var valSeconds = parseInt(value) || 0;
                            var valMinutes = parseInt(valSeconds / 60);

                            valSeconds = valSeconds - (valMinutes * 60);

                            var tickLabel = value;
                            if (valMinutes > 0) {
                                var tickLabel = ("00" + valMinutes).slice(-2) + ":" + ("00" + valSeconds).slice(-2) + "." + (valHundredths + "00").slice(0,2);
                            }
                            else {
                                var tickLabel = ("00" + valSeconds).slice(-2) + "." + (valHundredths + "00").slice(0,2);
                            }


                            console.log('Formatted label is ' + tickLabel);

                            return tickLabel;
                        }
                      }
                    }]
                  }
                };
            }
        
        },

    mounted() {
        this.setInitialDateFilter();
        this.createChart();
        this.setChartOptions();
        this.fetchTimes();
    }
}
</script>